module.exports = __webpack_public_path__ + "static/media/Team 4 - Going The (Social) Distance.a7281b93.png";